module.exports = __webpack_public_path__ + "static/media/wis.75adee82.png";


//////////////////
// WEBPACK FOOTER
// ./src/wis.png
// module id = 337
// module chunks = 0